import Vue from 'vue'
import Vuex from 'vuex'
import rootModule from './rootModule'
import logger from './plugins/logger'
import mqtt from './plugins/mqtt'
import pingCloud from './plugins/pingCloud'
import myProfile from './modules/myProfile'
import sites from './modules/sites'
import cameras from './modules/cameras'
import events from './modules/events'
import users from './modules/users'
import contacts from './modules/contacts'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: rootModule.state,
  actions: rootModule.actions,
  getters: rootModule.getters,
  mutations: rootModule.mutations,
  modules: {
    myProfile,
    sites,
    cameras,
    events,
    users,
    contacts
  },
  plugins: [logger, mqtt, pingCloud],
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js